import { useTranslations } from '@vocab/react';
import { Notice, Text } from 'braid-design-system';
import type React from 'react';

import translations from './.vocab';
interface Props {
  isServerError: boolean;
  error: string;
}

export const ErrorNotice: React.FC<React.PropsWithChildren<Props>> = ({
  isServerError,
  error,
}: Props) => {
  const { t } = useTranslations(translations);

  if (isServerError) {
    return (
      <Notice tone="critical">
        <Text>{t('Sorry we couldnt save your changes...')}</Text>
      </Notice>
    );
  }

  if (error !== '') {
    return (
      <Notice tone="critical">
        <Text>{error}</Text>
      </Notice>
    );
  }

  return null;
};
